import { render, staticRenderFns } from "./PhoneFieldRu.vue?vue&type=template&id=169927fc&scoped=true"
import script from "./PhoneFieldRu.vue?vue&type=script&lang=js"
export * from "./PhoneFieldRu.vue?vue&type=script&lang=js"
import style0 from "./PhoneFieldRu.vue?vue&type=style&index=0&id=169927fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169927fc",
  null
  
)

export default component.exports